export default __webpack_public_path__ + "static/media/diamond-cut-4@3x.1a4b5b84.png";